export type DemoTab = 'overview' | 'claims' | 'drift';

export const DEMO_BRAND = {
  name: 'Northstar Analytics',
  domain: 'northstaranalytics.example',
  color: '#1b87e6',
};

export const DEMO_SOV = [
  { name: 'Northstar Analytics', pct: 42, color: '#1b87e6' },
  { name: 'Signalboard', pct: 28, color: '#6b7a90' },
  { name: 'Metricly', pct: 18, color: '#9aa6b2' },
  { name: 'Other', pct: 12, color: '#c5ccd4' },
];

export const DEMO_RANKS = [
  { engine: 'ChatGPT', rank: 2, mentioned: true },
  { engine: 'Gemini', rank: 1, mentioned: true },
  { engine: 'Perplexity', rank: 3, mentioned: true },
];

export const DEMO_CLAIMS = [
  {
    text: 'Northstar Analytics offers unlimited seats on all plans.',
    status: 'False' as const,
    severity: 'High' as const,
    engine: 'ChatGPT',
  },
  {
    text: 'SOC 2 Type II certification was completed in 2024.',
    status: 'True' as const,
    severity: 'Medium' as const,
    engine: 'Gemini',
  },
  {
    text: 'Native Salesforce sync is available on Growth.',
    status: 'Stale' as const,
    severity: 'Medium' as const,
    engine: 'Perplexity',
  },
  {
    text: 'Average implementation takes under two weeks.',
    status: 'Unverifiable' as const,
    severity: 'Low' as const,
    engine: 'ChatGPT',
  },
];

export const DEMO_DRIFT = {
  fixed: 6,
  newIssues: 2,
  persisted: 4,
  sovDelta: '+8 pts',
  rankNote: 'Gemini rank held at #1; ChatGPT improved 3 → 2',
  rows: [
    {
      label: 'Unlimited seats claim',
      change: 'Fixed',
      detail: 'No longer appears in ChatGPT answers',
    },
    {
      label: 'Salesforce sync on Growth',
      change: 'Persists',
      detail: 'Still cited from an outdated comparison page',
    },
    {
      label: 'New pricing tier mention',
      change: 'New',
      detail: 'Perplexity introduced an incorrect starter price',
    },
  ],
};
